/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Pipe, PipeTransform} from '@angular/core';
import {MenuItem} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  name: 'translateMenuItems',
  pure: true
})
export class TranslateMenuItemsPipe implements PipeTransform {

  currentLang: string | null = null;

  items = null;

  constructor(private translateService: TranslateService) {
  }

  transform(value: MenuItem[], path?: string): any {
    if (this.currentLang === null) {
      this.currentLang = this.translateService.currentLang
    }
    this.items = this.translate(value, path);
    return this.items
  }

  translate(value: MenuItem[], path: string | null) {

    const translatedMenuItems = value.map((item: MenuItem) => ({ ...item, label: this.translateService.instant(path ? `${path}.${item.label}` : item.label, {defaultValue: item.label}) }));

    return translatedMenuItems?.map((item) => {
      if(item?.items) {
        item.items = this.translate(item?.items, path);
      }
      return item
    })
  }

}
